/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { systemConfigurationGeneralResource } from '@jira/router-resources__system-configuration-settings/src/systemConfigurationGeneralResource.tsx';
import { systemConfigurationRoute } from '@jira/router-routes__admin-pages-system-configuration-routes/src/systemConfigurationRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import SystemConfigurationGeneral, {
	LazySystemConfigurationGeneral,
} from './ui/spa/admin-pages/system-configuration/async.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const systemConfigurationRouteEntry: Route = createEntry(systemConfigurationRoute, () => ({
	group: 'global-settings',
	// eslint-disable-next-line no-restricted-syntax
	component: SystemConfigurationGeneral,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		systemConfigurationGeneralResource,
		conditionalPostOfficeJiraTopBannerResource,
	],

	forPaint: [LazyAtlassianNavigation, LazySystemConfigurationGeneral],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
